import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
//import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as dataAction from "../../../store/ZGF0YVRlYW1SZXBvcnQ/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
//import moment from "moment"
import api from "helpers/Api"
import ReactDOM from 'react-dom'
import MonthWiseTableComponent from "./DataTeamTabComponent"
import "./styles.scss"
import Select from "react-select"


const DataTeamReport = (props) => {
  const { searchBtnStyle, dispatch } = props

  const title = "Data Team Report - Monthwise Service Copy Status"

  //Fetching API
  useEffect(() => {
    dispatch(dataAction.loadProductStatus())
    dispatch(dataAction.loadRecordsMetaData())
  }, [])
  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //date format
  const update = useSelector(
    (specificstate) => specificstate.dataTeamReport
  )
  //product_data
  const { recordsMetaData = {}, product_data = [] } = update

  //Handle Change  
  const [dataTeamData, setDataTeamData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })

  const handleChange = (e) => {
    setDataTeamData({
      ...dataTeamData,
      [e.target.name]: e.target.value,
    })
  }

  const [downloadLoading, setDownloadLoading] = useState(false)
  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)
  const [service, setService] = useState([])
  //serviceOptions
  const serviceOptions = !isEmpty(recordsMetaData) && !isEmpty(recordsMetaData.serviceOptions) ?
  recordsMetaData.serviceOptions.filter(m=>m.isDataApplicable == true).reduce((acc, m) => {
      if (!acc.some(option => option.label === m.label)) {
        acc.push({ label: m.label, value: m.value })
      }
      return acc
    }, []) : []


  const handleFilter = (e) => {
    e.preventDefault()

    var searchService = !isEmpty(service) && service ? serviceValue : ""
    var searchFromDate =
      dataTeamData && dataTeamData.eventFromDate
        ? moment(dataTeamData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      dataTeamData && dataTeamData.eventToDate
        ? moment(dataTeamData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchService) {
      searchvalue.serviceId = searchService
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    // setSearchValue(searchvalue)
    dispatch(dataAction.loadProductStatus(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 3000)
  }

  //reset
 
  const resetForm = () => {
    setService([])
    setSearchInput("")
    setDataTeamData({
      ...dataTeamData,
      eventFromDate: "",
      eventToDate: "",
    })
    dispatch(dataAction.loadProductStatus())
  }

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      dataAction.loadProductStatus({
        searchFilter: searchInput,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const serviceValue = !isEmpty(service) && service ? service.map(m=>m.value):[]
  const exportToCsv = () => {
    var searchService = !isEmpty(service) && service ? serviceValue : ""
    var searchFromDate =
      dataTeamData && dataTeamData.eventFromDate
        ? moment(dataTeamData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      dataTeamData && dataTeamData.eventToDate
        ? moment(dataTeamData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchService) {
      searchvalue.serviceId = searchService
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    setDownloadLoading(true)

    api
      .post(`/get-data-copy-team-report-monthly-wise`, searchvalue)
      .then((response) => {

        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        const product_datas = response.data.data || []
        const monthsHeader = product_datas.length > 0 ? (() => {
          const firstSubStatusKey = Object.keys(product_datas[0].subStatus)[0]
          const monthData = product_datas[0].subStatus[firstSubStatusKey]

          return Object.entries(monthData).map(([key]) => {
            const [year, monthIndex] = key.split('_')
            const monthName = monthNames[parseInt(monthIndex, 10) - 1]

            return `${monthName} - ${year}`
          })
        })() : []

        const photoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const subStatusKeys = Object.keys(data.subStatus)

            const subStatusCounts = monthsHeader.map((monthHeader) => {
              const [month, year] = monthHeader.split(' - ')
              const monthIndex = monthNames.indexOf(month) + 1
              const monthKey = `${year}_${monthIndex.toString().padStart(2, '0')}`

              return subStatusKeys.reduce((acc, status) => {
                acc[status] = (data.subStatus[status] && data.subStatus[status][monthKey]) || 0
                return acc
              }, {})
            })

            return {
              _id: index,
              sNo: index + 1,
              serviceName: data.serviceName,
              subStatus: subStatusKeys.join("\n"),
              subStatusCounts
            }
          }) : []

        setTimeout(() => {
          let csvContent = `S.No,Service Name,Sub Status,${monthsHeader.join(",")}\n`

          photoExportDataTable.forEach((row) => {
            const statusLines = row.subStatus.split("\n")

            statusLines.forEach((status, i) => {
              if (i === 0) {
                csvContent += `${row.sNo},${row.serviceName},"${status}"`
              } else {
                csvContent += ',,"' + status + '"'
              }

              monthsHeader.forEach((monthHeader, monthIndex) => {
                const statusCounts = row.subStatusCounts[monthIndex]
                csvContent += `,${statusCounts[status] || 0}`
              })

              csvContent += "\n"
            })
          })

          downloadFile({
            data: csvContent,
            fileName: "DataTeamReport.csv",
            fileType: "text/csv",
          })

          setDownloadLoading(false)
        }, 1000)

        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }


  const handleClickTab = (tableData) => {
    const dateStr = tableData.month
    const [year, month] = dateStr.split("_")
    const formattedDate = `${year}-${month}-01`
    const statusName = tableData.status
    const date = tableData.date
    let statusDetails = {
      "year_month":formattedDate,
      "serviceLevelStatus":statusName,
      "serviceName": tableData.serviceName
    }

    api
      .post(`/get-data-copy-team-details`, statusDetails)
      .then((response) => {
        const statusData = !isEmpty(response.data.data) ? response.data.data : []
        setTimeout(() => {
         

          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <MonthWiseTableComponent
                data={statusData} 
                dispatch={dispatch}
                statusPayload={statusDetails}
                name={statusName}
                dateFormat={dateFormat}
                date={date}
              />,
              container
            )
            newTab.document.title = "MONTH-WISE-CLIENT-DELIVERABLE"
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)

      })
  }
 
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Service"}
                        >
                          {"Service"}
                        </Label>
                      </div>

                      <Select
                        type="text"
                        name="service"
                        value={service}
                         isMulti
                        onChange={(e) => setService(e)}
                        options={serviceOptions}
                        placeholder="Select Service"
                        classNamePrefix="select2-selection"
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 20, // Ensures the dropdown appears above other content
                          }),
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Event Date"}>
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={dataTeamData.eventFromDate}
                        max={dataTeamData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={dataTeamData.eventToDate}
                        min={dataTeamData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>

                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>
                <Row>
                  <Col md="4" lg="4" sm="12"></Col>
                  <Col
                    md="8"
                    lg="8"
                    sm="12"
                    style={{ marginBottom: "20px", marginTop: "-41px" }}
                  >
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Col md="12" lg="12" xl="12" className="mt-3">
                  <div style={{ overflowX: "auto" }}>
                    <Table bordered style={{ minWidth: "100%" }}>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "50px", position: "sticky", left: 0, zIndex: 1, backgroundColor: "#F8F8FB" }}>S.No</th>
                          <th style={{ minWidth: "190px", position: "sticky", left: "50px", zIndex: 1, backgroundColor: "#F8F8FB" }}>Service Name</th>
                          <th style={{ minWidth: "190px", position: "sticky", left: "240px", zIndex: 1, backgroundColor: "#F8F8FB" }}>Sub Status</th>

                          {!isEmpty(product_data) && product_data.length > 0 ? (() => {
                          
                            const firstSubStatusKey = product_data[0].subStatus && Object.keys(product_data[0].subStatus).length > 0
                              ? Object.keys(product_data[0].subStatus)[0]
                              : ""

                            const monthData = firstSubStatusKey ? product_data[0].subStatus[firstSubStatusKey] : {}

                            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

                            return Object.entries(monthData).map(([key]) => {
                              const [year, monthIndex] = key.split('_')
                              const monthName = monthNames[parseInt(monthIndex, 10) - 1]

                              return (
                                <th
                                  style={{ minWidth: "120px" }}
                                  key={key}
                                >
                                  {`${monthName} - ${year}`}
                                </th>
                              )
                            })
                          })() : []}


                        </tr>
                      </thead>
                      <tbody>
                        {product_data &&
                          !isEmpty(product_data) &&
                          product_data.length > 0
                          ? product_data.map((product, index) => {

                            const subStatusKeys = Object.keys(product.subStatus)
                            const monthHeaders = Object.keys(product.subStatus[subStatusKeys[0]])
                            return (
                              <>
                                <tr key={index}>
                                  <td style={{ minWidth: "50px", position: "sticky", left: 0, zIndex: 1, backgroundColor: "#F8F8FB" }}>{index + 1}</td>
                                  <th style={{ minWidth: "190px", position: "sticky", left: "50px", zIndex: 1, backgroundColor: "#F8F8FB" }}>{product.serviceName}</th>
                                  <th className="mx-2" style={{ minWidth: "190px", position: "sticky", left: "240px", zIndex: 1, backgroundColor: "#F8F8FB" }}>
                                    {
                                      subStatusKeys.map((status, index, statusesArray) => (
                                        <span
                                          key={index}
                                          className={index !== statusesArray.length - 1 ? "process-status-row" : "process-last-row"}
                                        >
                                          {status}
                                        </span>
                                      ))}

                                  </th>
                                  {monthHeaders.map((monthKey) => (
                                    <td key={monthKey} className="text-align-center" style={{ minWidth: "120px" }}>
                                      {subStatusKeys.map((status, statusIndex) => {
                                        const count = product.subStatus[status][monthKey] || 0
                                        const tableData = {
                                          status: status,
                                          serviceName:product.serviceName,
                                          month:monthKey
                                        }
                                        return (
                                          <span
                                            key={statusIndex}
                                            className={
                                              statusIndex !== subStatusKeys.length - 1
                                                ? "status-row"
                                                : "last-row"
                                            }
                                            onClick={() => handleClickTab(tableData)}
                                          >
                                            {count}
                                          </span>
                                        )
                                      })}
                                    </td>
                                  ))}

                                </tr>
                              </>
                            )
                          })
                          : ""}
                      </tbody>
                    </Table>
                  </div>
                  <div className="font-size-14 mt-2">
                    <p>
                      {" "}
                      <p>{`Showing rows ${product_data && product_data.length > 0 ? 1 : 0
                        } to ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        } of ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        }`}</p>
                    </p>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
DataTeamReport.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,DataTeamReport
})
//DataTeamReport
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DataTeamReport)
)
